
<template>
   <div class="Homecontainer">
    <my-header></my-header> 
    <!-- 内容 -->
    <full-page :options="options">
      <!-- 联系我们 -->
      <div class="section section5">
        <div class="box5">
          <div class="fifth-floor">
            <p class="title">联系我们</p>
            <div class="fifth-content" >
              <div class="left">
                <p class="address" style="display:flex">地址: <span>河南省郑州市金水区东风路3号财智名座</span></p>
                <p class="phone">电话: 0371-63597329</p>
                <p class="email">邮箱: contact@bisense.cn</p>
              </div>
              <div class="right">
                <img src="../assets/img/bangonglou zhaopian.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <my-footer></my-footer> 
    </full-page>
  </div>
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios';
  import myHeader from '@/components/Header.vue'
  import myFooter from '@/components/Footer.vue'
  import { Carousel} from 'element-ui';
  import FullPage from '@/components/FullPage/FullPage.vue'
  Vue.use(Carousel)
  export default {
    data() {
      return {
        homeNews:{},
        example0:"",
        options: {
          licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
          afterLoad: this.afterLoad,
          anchors: ['page1'],
          scrollBar: false,
          menu: "#menu",
        }
      }
    },
    mounted() {
    },
    components:{
      myHeader,
      myFooter,
      FullPage
    },
  }
</script>
<style scoped lang = 'scss'>
  @import '@/lib/reset.scss';
  .Homecontainer{
    .contauner-fliud{
      width:100%;
      height: 100%;
    }
    .section{
      position: relative;
    } 
    /* 联系我们 */
    .section5{
      width: 100%;
      background-image: url('../assets/img/dabeijing5.png');
      background-size:100% 100%;
    }
    .fifth-floor{
      position: absolute;
      z-index: 1;
      top:20%;
    }
    .fifth-floor .title {
      font-size:35px;
      color: #fff;
      padding: 44px 115px;
      margin:0% 13%;
      background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
      background-size: 303px 134px;
    }
    .fifth-content{
      display: flex;
      font-size: 25px;
      color: #555555;
      margin:1% 3%;
    }
    .fifth-floor .fifth-content .left{margin-left:10%;}
    .fifth-content .address::before{
      content:url(../assets/img/dizhitubiao.png);
      margin-right: 2%;
      vertical-align: middle;
    }
    .fifth-content .phone::before{
      content: url(../assets/img/dinahuatubiao.png);
      margin-right: 1%;
      vertical-align: middle;
    }
    .fifth-content .email::before{
      content: url(../assets/img/e-mail.png);
      margin-right: 1%;
      vertical-align: middle;
    }
    .fifth-content .left {
      white-space:nowrap;
      line-height: 10px;
      margin:11% 0 0 0%;
    }
    .fifth-content .left p{
      line-height: 40px;
    }
    .fifth-content .right {
      position: relative;
      margin: 0 3%
    }
    @media screen and (max-width:1680px) and (min-width:1440px){
      /* 联系我们 */
      .fifth-floor .title {
        font-size:35px;
        color: #fff;
        padding: 42px 110px;
        margin:0% 180px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size: 300px 134px;
      }
      .fifth-content{
        font-size: 23px;
        margin:1% -5%; 
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:6% 0 0 0%;
      }
      .fifth-content .left p{
        line-height:28px;
      }
      .fifth-content .right {
        margin: 0 2%
      }
      .fifth-content .right img{
        width: 90%; 
      }
      .fifth-floor .fifth-content .left{margin-left:16%;}
    }
    @media screen and (max-width:1440px) and (min-width:1366px){
      /* 联系我们 */
      .fifth-floor .title {
        font-size:30px;
        color: #fff;
        padding: 40px 85px;
        margin:0% 170px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size: 240px 120px;
      }
      .fifth-content{
        font-size: 21px;
        color: #555555;
        margin:1% -2%; 
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:7.5% 0 0 0%;
      }
        .fifth-content .left p{
        line-height:25px;
      }
      .fifth-content .right img{
        width:93%;
      }
      .fifth-floor .fifth-content .left{margin-left:14%;}
    }
    @media screen and (max-width:1366px) and (min-width:1280px){
      /* 联系我们 */
      .fifth-floor .title {
        font-size:26px;
        color: #fff;
        padding: 30px 70px;
        margin:0% 150px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size:200px 95px;
      }
      .fifth-content{
        font-size:19px;
        margin:0% 0%;
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:8% 0 0 0%;
      }
      .fifth-content .right img{
        width:87%;
      }
      .fifth-content .left p{
        line-height:22px;
     
      }
      .fifth-floor .fifth-content .left{margin-left:12%;}
    }
    @media screen and (max-width:1280px) and (min-width:1024px){
      /* 联系我们 */
      .fifth-floor .title {
        font-size:26px;
        color: #fff;
        padding: 30px 70px;
        margin:0% 150px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size:200px 95px;
      }
      .fifth-content{
        font-size: 19px;
        margin:0% 0%;
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:7% 0 0 0%;
      }
      .fifth-content .right img{
        width:85%;
      }
      .fifth-content .left p{
        line-height:22px;
      }
        .fifth-floor .fifth-content .left{margin-left:12%;}
    }
    @media screen and (max-width:1024px)and (min-width:650px){
      /* 联系我们 */
      .fifth-floor .title {
        font-size:26px;
        color: #fff;
        padding: 30px 70px;
        margin:0% 150px;
        background:url(../assets/img/lianxiwomentubiao.png) no-repeat;
        background-size:200px 95px;
      }
      .fifth-content{
        font-size:18px;
        margin:2% 0%;
      }
      .fifth-floor .fifth-content .left {
        white-space: pre-wrap;
        margin:7% 0 0 0%;
      }
      .fifth-content .right img{
        width:92%;
      }
      .fifth-content .left p{
        line-height:22px;
      }
      .fifth-floor .fifth-content .left{margin-left:16%;}
    } 
  }
</style>



// WEBPACK FOOTER //
// src/components/Recruit.vue